namespace Gamification.Gamification {
    export interface AttivazioneRequest extends Serenity.ServiceRequest {
        NewPassword?: string;
        ConfirmPassword?: string;
    }
}
